import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { Autocomplete, TextField, Typography } from "@mui/material";

export type GenericSearchSelectProps = {
  value: string | null | undefined;
  setValue: (value: string | null) => void;
  options: string[];
  label: string;
  disabled?: boolean;
};

export const GenericSearchSelect = ({
  value,
  setValue,
  options,
  label,
  disabled = false,
}: GenericSearchSelectProps) => {
  return (
    <Autocomplete
      disablePortal
      options={options}
      fullWidth
      sx={{
        "& .MuiAutocomplete-inputRoot.Mui-disabled:before": {
          borderBottom: "none",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          key={`${label}-select`}
          label={label}
          autoComplete="off"
        />
      )}
      isOptionEqualToValue={(option, value) => {
        if (value === "") return false;
        return option === value;
      }}
      disabled={disabled}
      value={value || null}
      onChange={(_, newValue) => {
        setValue(newValue);
      }}
      renderOption={(props, option) => (
        <li {...props} key={`li-${option}`}>
          <div className="flex gap-3">
            <div className="flex items-center justify-center">
              <PermIdentityIcon />
            </div>
            <div>
              <Typography variant="body1" fontWeight="500">
                <span>{option}</span>
              </Typography>
            </div>
          </div>
        </li>
      )}
      ListboxProps={{ style: { maxHeight: 200 } }}
      getOptionLabel={(option) => option}
    />
  );
};

export default GenericSearchSelect;
